import { IApplicationState } from '../../types/redux';
import { prepareRateTitleByDate } from '../../utils/prepareRateTitleByDate';

export function getFskCalculator(state: IApplicationState) {
  if (!state.fsk?.mortgageCalculatorBanner || !state.fsk.baseCalculatorConfig) {
    return null;
  }

  return {
    ...state.fsk.baseCalculatorConfig,
    rate: {
      title: prepareRateTitleByDate(state.fsk.baseCalculatorConfig.rate.title),
      tooltip: state.fsk.mortgageCalculatorBanner.hint,
      defaultValue: Number(state.fsk.mortgageCalculatorBanner.ratePercent),
      label: `${state.fsk.mortgageCalculatorBanner.ratePercent}%`,
    },
  };
}
